import { withProperties } from "../../../../utils";
import withReactiveFields from "../../helpers/reactivefields";
import { USES_CHARGE_POLLING } from "../../../../charge/flags";
import getChargeLimit from "../../../../lookup/limit";
import getChargeFee from "../../../../lookup/fee";
import Device from "../../../../init/device";

import InitView from "./views/init";
import RedirectView from "../../common/redirect";

const METHOD = 'opay';
const METHOD_NAME = 'OPay';
const CHARGE_MODE = USES_CHARGE_POLLING;

const VIEWS = [ InitView ];

function mount() {
    return (dispatch) => {
        getChargeLimit.call(this, () => {
            const VIEW = (
                this.REDIRECT_URL && (RedirectView || (this.REDIRECT_URL = null))
            ) || InitView;
            
            VIEW && VIEW.activate.call(this);
        });

        getChargeFee();
    }
}

/**
 * Generates charge data for the Opay payment method.
 * @returns {Object} Charge data object.
 * @property {string} payment_type - Always 'opay'.
 * @property {string} customer_visit_source - Device type: 'IOS', 'ANDROID', or 'BROWSER'.
 * @property {boolean} evoke_opay - Whether to trigger the native Opay app (mobile only).
 */
function getChargeData() {
    // Device.deviceType returns 'IOS' | 'ANDROID' | 'BROWSER'.
    const customer_visit_source = Device.deviceType;

    // evoke_opay is true only when the customer is on a mobile source (IOS/ANDROID).
    const evoke_opay = customer_visit_source === 'IOS' || customer_visit_source === 'ANDROID';

    return ({
        payment_type: 'opay',
        customer_visit_source,
        evoke_opay
    });
}

function getViewsContext(data, store) {
    const REACTIVE_FIELDS = ['REDIRECT_URL'];
    const $context = withReactiveFields(Object.create(null), ...REACTIVE_FIELDS);

    $context.$subscribe('REDIRECT_URL', (currentValue, oldValue) => {
        setTimeout(() => {
            if (!(oldValue && oldValue === currentValue) && currentValue instanceof URL) {
                RedirectView && RedirectView.activate.call($context);
            }
        }, 0);
    });

    return withProperties($context, {
        INIT_VIEW: callback => {
            InitView && InitView.activate(callback);
        }
    });
}

export {
    METHOD,
    METHOD_NAME,
    CHARGE_MODE,
    VIEWS,
    mount,
    getChargeData,
    getViewsContext
}
